<template>
	<div class="extensionTimeCell">
		<el-tooltip placement="top" :disabled="!row.origin_promotion_start_time">
			<div slot="content">
				一级团长推广时间：
				<br />
				{{ row.origin_promotion_start_time }}
				<span class="ml-6 mr-6">至</span>
				{{ row.origin_promotion_end_time }}
			</div>
			<div>
				<span>{{ row.promotion_start_time }}</span>
				<span class="division">-</span>
				<span>{{ row.promotion_end_time }}</span>
			</div>
		</el-tooltip>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.division {
	margin: 0px 2px;
}
</style>